export interface StructuredError {
  title: string;
  message: string;
  description?: string;
  recommendation?: string;
  type?: 'error' | 'warning' | 'information';
  iconname?: string;
}

export function extractErrorDetails(error: any, snackBarObj:any): StructuredError {
  let title = 'Error';
  let message = 'An unexpected error occurred.';
  let description = '';
  let recommendation = snackBarObj?.snackBarRecommendation || 'Please try again. If the problem persists, contact support.';
  let type: 'error' | 'warning' | 'information' = 'error';
  let iconname = 'error_outline';

  if (typeof error === 'string') {
    message = error;
  } else if (error && typeof error === 'object') {
    // Attempt to extract from common error structures
    if (error.message) {
      message = error.message;
    }
    if (error.title) {
      title = error.title;
    }
    if (error.description) {
      description = error.description;
    }
    if (error.recommendation) {
      recommendation = error.recommendation;
    }
    if (error.type && ['error', 'warning', 'information'].includes(error.type)) {
      type = error.type;
    }

    // Specific checks for different error sources (e.g., HttpErrorResponse)
    if (error.error && typeof error.error === 'object') {
      if (error.error.message) message = error.error.message;
      if (error.error.title) title = error.error.title;
      if (error.error.description) description = error.error.description;
      if (error.error.recommendation) recommendation = error.error.recommendation;
    } else if (error.error && typeof error.error === 'string'){
      message = error.error;
    }

    //if description is empty, then set it to error.error
    if(!description) description = JSON.stringify(error.error || error);

    if (error.statusText && !message) {
      message = error.statusText;
    }
    if (error.status && !title) {
      title = `Error ${error.status}`;
    }
  }

  return {
    title,
    message,
    description,
    recommendation,
    type,
    iconname
  };
}